/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/
import React from "react";
import { Dialog, Slide, Box, IconButton } from "@mui/material";
import { Close } from "@mui/icons-material";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

class DialogContainer extends React.Component {
  render() {
    return (
      <Dialog
        fullWidth
        open={this.props.open}
        onClose={this.props.handleClose}
        TransitionComponent={Transition}
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: "16px", // Rounded corners
            boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.3)", // Soft shadow
            padding: "10px",
            color: "white",
          },
        }}
      >
        {/* Close Button */}
        <Box display="flex" justifyContent="flex-end">
          <IconButton onClick={this.props.handleClose} sx={{ color: "white" }}>
            <Close />
          </IconButton>
        </Box>

        {/* Dialog Content */}
        <Box p={2}>
          {React.cloneElement(this.props.children, {
            primary: this.props.primary,
            handleClose: this.props.handleClose,
          })}
        </Box>
      </Dialog>
    );
  }
}

export default DialogContainer;
